import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  confirmationContainer: {
    padding: '0px 24px',
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
  },
  reason: {
    borderRadius: 6,
    minHeight: 240,
    maxHeight: 240,
    overflow: 'auto !important',
    width: '100%',
    marginTop: 5,
    resize: 'none',
    border: '1px dashed #c4c4c4',
    padding: 10,
  },
}))
